import { type ReactNode } from 'react';

import { SplitView } from './SplitView';

export type BuilderLayoutProps = {
  header: ReactNode;
  footer: ReactNode;
  sidebarContent: ReactNode;
  mainContent: ReactNode;
  previewContent: ReactNode;
};

export function BuilderLayout({
  header,
  footer,
  sidebarContent,
  mainContent,
  previewContent,
}: BuilderLayoutProps) {
  return (
    <div className="min-h-screen h-screen flex flex-col overflow-hidden">
      {header}
      <div className="flex-1 flex overflow-hidden">
        <aside className="w-[200px] border-r border-[var(--border)] bg-[var(--popover)] overflow-y-auto overflow-x-hidden">
          {sidebarContent}
        </aside>
        <SplitView
          left={
            <div className="h-full overflow-y-auto overflow-x-hidden p-4 bg-[var(--popover)]">
              {mainContent}
            </div>
          }
          right={
            <div className="h-full overflow-y-auto overflow-x-hidden p-4 bg-[var(--popover)]">
              {previewContent}
            </div>
          }
          minLeftWidth={400}
          maxLeftWidth={800}
          initialLeftWidth={600}
          className="flex-1"
        />
      </div>
      {footer}
    </div>
  );
}
